export default "__VITE_ASSET__iGprzwTO__"